"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthMethods = void 0;
var AuthMethods;
(function (AuthMethods) {
    AuthMethods["PolicyholderToken"] = "bearer-policyholder";
    AuthMethods["PortalToken"] = "bearer-portal";
    AuthMethods["PolicyholderSessionId"] = "policyholder-session-id";
    AuthMethods["CognitoToken"] = "bearer-cognito";
    AuthMethods["None"] = "none";
    AuthMethods["ApiKey"] = "api-key";
    AuthMethods["Disabled"] = "bearer-disabled";
    AuthMethods["ClientSecret"] = "bearer-secret";
})(AuthMethods = exports.AuthMethods || (exports.AuthMethods = {}));
//# sourceMappingURL=authentication-methods.js.map